import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalUploadComponent } from './components/modal-upload/modal-upload.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StockDetailModalComponent } from './components/stock-detail-modal/stock-detail-modal.component';
import { EditStockModalComponent } from './components/edit-stock-modal/edit-stock-modal.component';
import { AuthDialogComponent } from './components/auth-dialog/auth-dialog.component';
import { BalanceDialogComponent } from './components/balance-dialog/balance-dialog.component';
import { BankDialogComponent } from './components/bank-dialog/bank-dialog.component';
import { ProfileDialogComponent } from './components/profile-dialog/profile-dialog.component';
import { ChangePasswordDialogComponent } from './components/change-password-dialog/change-password-dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { HammerModule } from '@angular/platform-browser';
import { ChatBubbleComponent } from './components/chat-bubble/chat-bubble.component';
import { MyStockComponent } from './components/my-stock/my-stock.component';



@NgModule({
  declarations: [
    ModalUploadComponent,
    StockDetailModalComponent,
    EditStockModalComponent,
    AuthDialogComponent,
    BalanceDialogComponent,
    BankDialogComponent,
    ProfileDialogComponent,
    ChangePasswordDialogComponent,
    FooterComponent,
    ChatBubbleComponent,
    MyStockComponent
  ],
    exports: [ModalUploadComponent, StockDetailModalComponent, EditStockModalComponent, AuthDialogComponent, BalanceDialogComponent, BankDialogComponent, ProfileDialogComponent, ChangePasswordDialogComponent, FooterComponent, ChatBubbleComponent, MyStockComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HammerModule
  ]
})
export class SharedModule { }
